/* eslint-disable react/prop-types */
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

export default function WeeklyTitheWelfareChart({ data }) {
  const theme = useTheme();

  const hasData = data && data.length > 0 && data.some((d) => d.tithe > 0 || d.welfare > 0);

  if (!hasData) {
    return (
      <Box sx={{ py: 4, textAlign: "center" }}>
        <Typography variant="body2" color="text.secondary">
          No tithe or welfare payments recorded in the last 7 days.
        </Typography>
      </Box>
    );
  }

  const chartData = {
    labels: data.map((d) => d.day),
    datasets: [
      {
        label: "Tithe",
        data: data.map((d) => d.tithe),
        backgroundColor: theme.palette.teal[400],
        hoverBackgroundColor: theme.palette.teal[600],
        borderRadius: 6,
        maxBarThickness: 28,
      },
      {
        label: "Welfare",
        data: data.map((d) => d.welfare),
        backgroundColor: theme.palette.purple?.[400] || theme.palette.info.main,
        hoverBackgroundColor: theme.palette.purple?.[600] || theme.palette.info.dark,
        borderRadius: 6,
        maxBarThickness: 28,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: true, position: "top", align: "end" },
      tooltip: {
        callbacks: {
          title: (items) => data[items[0].dataIndex].date,
          label: (item) => `${item.dataset.label}: GHS ${Number(item.raw).toFixed(2)}`,
        },
      },
    },
    scales: {
      x: { grid: { display: false } },
      y: { beginAtZero: true, grid: { color: theme.palette.ink[100] } },
    },
  };

  return (
    <Box sx={{ height: 260 }}>
      <Bar data={chartData} options={options} />
    </Box>
  );
}
